import React, { useEffect, useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { ArrowUpward } from '@mui/icons-material';

export default function MoveUpButton(props) {

    const [scrolledDown, setScrolledDown] = useState(false);

    const moveUp = () => {
        window.scrollTo(0, 0)
    }

    const handleScrolledDown = () => {
        if (window.scrollY > 100) {
            setScrolledDown(true)
        } else {
            setScrolledDown(false);
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScrolledDown);


        // cleanup this component
    
        return () => {
    
          window.removeEventListener('scroll', handleScrolledDown);
    
        };
    }, [])

    if (scrolledDown) {
        return(
            <Box sx={{position: "fixed", bottom: 10, right: {xs: 20, sm: 40}}}>
                <IconButton onClick={moveUp}>
                    <ArrowUpward/>
                </IconButton>
            </Box>
        )
    } else {
        return null;
    }
}